// Neutral base used wherever a feed has no category assigned: the preview card
// and the source rows wash this gray instead of the feed's own color, since the
// category is what drives a feed's color in the experience. Uses the design-system
// gray token (color-mix in tint() accepts the CSS variable).
export const UNCATEGORIZED_FEED_COLOR = 'var(--chakra-colors-gray-600)';
